import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const CheckIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.1968 7.21735L9.0898 18.0039L3.79297 12.7071L5.20718 11.2929L9.11035 15.196L18.8034 5.78259L20.1968 7.21735Z"
          fill="#333333"
        />
      </svg>
    )
  }
)
